import { render, staticRenderFns } from "./deliveryFee.vue?vue&type=template&id=c6551716&scoped=true"
import script from "./deliveryFee.vue?vue&type=script&lang=js"
export * from "./deliveryFee.vue?vue&type=script&lang=js"
import style0 from "./deliveryFee.vue?vue&type=style&index=0&id=c6551716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6551716",
  null
  
)

export default component.exports